import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {TransactionTypeBO} from "./TransactionTypeBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {WB_FundTypeRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";

export class TransactionTypeBOAudit {


    static async TransactionTypeAuditBO(TransactionTypeBO: TransactionTypeBO): Promise<AuditService> {

        const self = TransactionTypeBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("TransactionType", self.drWB_TransactionType.cif.WB_TXNTYPE_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const approvalParams: IAuditField [] = [
            {fieldName: "TXNTYPE_NAME",              realName: "Name"}, //create
            {fieldName: "TXNTYPE_ID",                realName: "ID"}, //create
            {fieldName: "RENDER_OPTIONS",  realName: "Render Options"},
            {fieldName: "SOURCE_ID",        realName: "Source"},
            {fieldName: "TREE_PATH",          realName: "Tree Path"},
            {fieldName: "MANUAL_IND",         realName: "Manual"},
            {fieldName:"CREDITDEBITPOLICY", realName:"Credit Debit Policy", domainId:"CreditDebitPolicy"},
            {fieldName:"BALANCEPOLICY", realName:"Balance Policy", domainId:"BalancePolicy"},
            {fieldName:"FUNDTYPEPOLICY", realName:"Fund Type Policy", domainId:"FundTypePolicy"},
            {fieldName:"CUSTOMERPOLICY", realName:"Customer Policy", domainId:"CustomerPolicy"},
            {fieldName:"CUSTOMERLEVEL", realName:"Customer Level", domainId:"Customer_Type"},
            {fieldName:"PRDGRPPOLICY", realName:"Product Group Policy", domainId:"PrdGrpPolicy"},
            {fieldName:"PRDGRPLEVEL", realName:"Product Group Level", domainId:"ProductGroup_Level"},
            {fieldName:"PERIODPOLICY", realName:"Period Policy", domainId:"PeriodPolicy"},
            {fieldName:"WB_PERIODM_ID", realName:"Period Level"},

        ]

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_TransactionType, approvalParams, {objectName: 'TransactionType', deletedKeys: deleteKeys})


        return auditService
    }



}
